export var globalStyles = function globalStyles(siteVars) {
  return {
    body: {
      padding: siteVars.bodyPadding,
      margin: siteVars.bodyMargin,
      fontFamily: siteVars.bodyFontFamily,
      fontSize: siteVars.bodyFontSize,
      lineHeight: siteVars.bodyLineHeight
    },
    '*': {
      boxSizing: 'border-box'
    },
    '*:before': {
      boxSizing: 'border-box'
    },
    '*:after': {
      boxSizing: 'border-box'
    },

    /* Adding priority for HTML `hidden` attribute to be applied correctly */
    '[hidden]': {
      display: 'none!important'
    }
  };
};